var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('base-card',[_c('v-card-title',[_vm._v(" To Be Developed - Notifications ")]),_c('v-card-text',[_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" Coming Soon - Tune in... ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }